export default __webpack_public_path__ + "static/media/travel.57fb673a.jpg";